module.exports = __webpack_public_path__ + "img/hongbao@3x.fea34ffe.png";